// extracted by mini-css-extract-plugin
export default {"threePointDiv":"responsiveStyles_threePointDiv__6dAs+","threePointDivInner":"responsiveStyles_threePointDivInner__ljSqa"};